const burger = document.querySelector(".burger");
const jounalNav = document.querySelector(".jounal__nav");
const promoNav = document.querySelector(".promo__nav");
const BntProjetBefore = document.querySelector(".projet__btn--before");
const BntProjetNext = document.querySelector(".projet__btn--next");

let ElProjetActive = document.querySelector(".projet__el--active");


if (BntProjetBefore) {
    BntProjetBefore.addEventListener("click", ShowBeforeEL);
}

if (BntProjetNext) {
    BntProjetNext.addEventListener("click", ShowNextEL);
}

function ShowBeforeEL() {

    if (!ElProjetActive) ElProjetActive = document.querySelector(".projet__el--active");
    if (!ElProjetActive) return;

    const ELProjetBefore = ElProjetActive.previousElementSibling || ElProjetActive.parentElement.lastElementChild;

    ElProjetActive.classList.remove("projet__el--active");
    ELProjetBefore.classList.add("projet__el--active");
    
    ElProjetActive = ELProjetBefore;
}

function ShowNextEL() {
    if (!ElProjetActive) ElProjetActive = document.querySelector(".projet__el--active");
    if (!ElProjetActive) return;

    const ElProjetNext = ElProjetActive.nextElementSibling || ElProjetActive.parentElement.firstElementChild;

    ElProjetActive.classList
    .remove("projet__el--active");
    ElProjetNext.classList.add("projet__el--active");
    
    ElProjetActive = ElProjetNext;
}
if (burger) {
    burger.addEventListener("click", openNav);

    function openNav() {
        burger.classList.toggle("open");
        document.documentElement.classList.toggle("noScroll");
        if (jounalNav) jounalNav.classList.toggle("open");
        if (promoNav) promoNav.classList.toggle("open");
        
    }
}
